export default __webpack_public_path__ + "static/media/insta.a5f27bc0.svg";